"use client";

import React, {
	useCallback,
	useEffect,
	useImperativeHandle,
	useRef,
	useState,
	forwardRef,
} from "react";
import { Autocomplete, CircularProgress } from "@mui/material";
import { debounce } from "lodash";
import { CustomTextField, CustomFormLabel } from "../formsComponents";
import { api } from "../../api/api";
import { IDisposition } from "../../views/rsaList/components/CloseComplaint/interfaces/ICcCloseComplaint";
import { initialDisposition } from "../../views/rsaList/components/CloseComplaint/interfaces/ICcCloseComplaint";

interface IDispositionAutoSearch {
	value: string;
	disabled: boolean;
	distinctDisposition: string;
	label: string;
	onSelect: (value: IDisposition) => void;
}

export const DispositionAutoSearch: React.FC<IDispositionAutoSearch> = (props) => {
	const { value, disabled, distinctDisposition, label, onSelect } = props;
	const [options, setOptions] = useState<readonly IDisposition[]>([]);
	const [loading, setLoading] = useState(false);
	const [search, setSearchText] = useState<string>("");
	
	

	const fetchSuggestion = async (enteredValue: string) => {
		setLoading(true);
		try {
			let searchQuery = "";
			if (enteredValue.length > 0) {
				searchQuery += `disposition=${enteredValue}&`;
			}
			
			const url = `/get-quick-rsa-help-disposition?disposition=${distinctDisposition}&pageNo=1&itemsPerPage=100`;

			const res = await api.get(url);
			const data: IDisposition[] = res.data.result;
			setOptions(data);
		} catch (error) {
			console.error("Error fetching data:", error);
			setOptions([]);
		} finally {
			setLoading(false);
		}
	};

	const debounceFn = useCallback(debounce(fetchSuggestion, 800), []);

	const getOptionLabel = (option: string | IDisposition) => {
		if (typeof option === "string") {
			return option;
		}
		if (option.sub_disposition) {
			return `${option.sub_disposition}`;
		}
		return `${option.sub_disposition || ""}`;
	};

	useEffect(() => {
		if (search && search !== value) {
			debounceFn(search);
		}
	}, [search, value, debounceFn]);

	useEffect(() => {
		fetchSuggestion("");
	}, []);

    const handleFocus = () => {
        if(distinctDisposition){
            fetchSuggestion(distinctDisposition);
        }
    }

	
	

	

	return (
		<>
			{label && <CustomFormLabel>{label}</CustomFormLabel>}
			<Autocomplete
				id="sub-disposition-auto-search"
				fullWidth
			
				freeSolo
				sx={{
					".MuiOutlinedInput-root": {
						paddingTop: "2px",
						paddingBottom: "2px",
						fontSize: "0.8rem",
						color: "rgb(38, 38, 38)",
						width: "100%",
					},
				}}
                onFocus={handleFocus}
				getOptionLabel={getOptionLabel}
				isOptionEqualToValue={(option, value) =>
					typeof option === "string"
						? option === value
						: typeof option !== "string" &&
						  typeof value !== "string" &&
						  option.sub_disposition === value.sub_disposition
				}
				filterOptions={(x) => x}
				options={options}
				autoComplete
				value={
					options.find((option) => option.sub_disposition === value) ||
					null
				}
				loading={loading}
				disabled={disabled}
				noOptionsText="Type to search"
				onChange={(event, value: string | IDisposition | null) => {
					if (typeof value === "object" && value !== null) {
						onSelect?.(value);
					} else {
						onSelect?.(initialDisposition);
					}
				}}
				onInputChange={(event, newInputValue) => {
					setSearchText(newInputValue);
				}}
				renderInput={(params) => (
					<CustomTextField
						{...params}
						fullWidth
						placeholder="Search Sub disposition"
						
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<React.Fragment>
									{loading && (
										<CircularProgress
											color="inherit"
											size={20}
										/>
									)}
									{params.InputProps.endAdornment}
								</React.Fragment>
							),
						}}
					/>
				)}
			/>
		</>
	);
};
